<footer *transloco="let t" class="footer-wrap mt-16 py-14">
    <div class="mx-auto max-w-screen-lg px-6 md:px-8 lg:px-0">
        <div class="grid gap-10 md:grid-cols-2 md:gap-16">
            <!-- Social -->
            <div>
                <h3 class="footer-heading mb-5">{{ t('footer.followUs') }}</h3>
                <div class="flex items-center gap-3">
                    <app-facebook-share></app-facebook-share>
                    <app-twitter-link-icon></app-twitter-link-icon>
                    <app-instagram-link-icon></app-instagram-link-icon>
                    <app-youtube-link-icon></app-youtube-link-icon>
                </div>
            </div>

            <!-- Pages -->
            <div>
                <h3 class="footer-heading mb-5">{{ t('footer.pages') }}</h3>
                <ul class="space-y-3">
                    <li>
                        <a
                            class="footer-link"
                            [routerLinkActive]="['footer-link-active']"
                            routerLink="page/{{ lang }}/{{pages[lang].contact}}"
                        >{{ t('footer.contact') }}</a>
                    </li>
                    <li>
                        <a
                            class="footer-link"
                            [routerLinkActive]="['footer-link-active']"
                            routerLink="page/{{ lang }}/{{pages[lang].about}}"
                        >{{ t('footer.aboutUs') }}</a>
                    </li>
                    <li>
                        <a
                            class="footer-link"
                            [routerLinkActive]="['footer-link-active']"
                            routerLink="page/{{ lang }}/{{pages[lang].privacyPolicy}}"
                        >{{ t('footer.privacyPolicy') }}</a>
                    </li>
                    <li>
                        <a
                            class="footer-link"
                            [routerLinkActive]="['footer-link-active']"
                            routerLink="page/{{ lang }}/{{pages[lang].tos}}"
                        >{{ t('footer.termsAndConditions') }}</a>
                    </li>
                </ul>
                <div class="mt-6">
                    <app-language-selector></app-language-selector>
                </div>
            </div>
        </div>

        <!-- Bottom bar -->
        <div class="mt-12 border-t border-white/10 pt-6">
            <p class="text-center text-xs text-white/40">
                &copy; {{ currentYear }} Quizzaro. All rights reserved.
            </p>
        </div>
    </div>
</footer>
